import { app } from '../../../../app';
import { Controller } from './add-note.controller';

app.component('userPublicNotesAdd', {
    controller: Controller,
    templateUrl: require('./add-note.html')
});


// WEBPACK FOOTER //
// ./src/portal/states/user/notes/add/add-note.component.js